import { useUser } from "contexts";
import { UserRoles } from "data/roles";
import { MoreItem } from "./MoreButton";
import PropTypes from "prop-types";
import { updateStory } from "services/stories";
import { moveToArchive } from "services/users";
import { ToggleButton } from "../StoryPreview";
import { Confirm } from "ui";

function ArchiveButton({ mode, onClose, story }) {
  const { hasRole } = useUser();

  if (!hasRole(UserRoles.ADMIN) || !story.isOwner) return null;

  const handleConfirm = () => {
    updateStory(story._id, { is_public: false });
    moveToArchive(story._id).then(() => onClose());
  };

  return (
    <Confirm
      title="Mover a archivo"
      description="¿Estás seguro de que quieres mover esta historia al archivo? Puedes acceder a ella más tarde desde el archivo."
      onConfirm={handleConfirm}
      confirmText="Archivar"
    >
      {mode === "menu" ? (
        <MoreItem icon="archive">Archivar</MoreItem>
      ) : (
        <ToggleButton icon="archive" label="Archivar" />
      )}
    </Confirm>
  );
}

ArchiveButton.propTypes = {
  mode: PropTypes.oneOf(["button", "menu"]),
  onClose: PropTypes.func.isRequired,
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
};

export default ArchiveButton;
